var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52608",
    "data-name": "Group 52608",
    transform: "translate(-808 -5023.653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_481",
    "data-name": "Ellipse 481",
    transform: "translate(808 5023.653)",
    fill: "#fff",
    stroke: "#93a750",
    strokeWidth: 1,
    strokeDasharray: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37,
    fill: "none"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_482",
    "data-name": "Ellipse 482",
    cx: 32.5,
    cy: 32,
    rx: 32.5,
    ry: 32,
    transform: "translate(813.5 5029.153)",
    fill: "#93a750"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46879",
    "data-name": "Group 46879",
    transform: "translate(552.168 8117.321)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 30.665,
    height: 30.665,
    transform: "translate(277 -3071)",
    fill: "#484848",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Calling",
    transform: "translate(282.112 -3065.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M.524,2.539C.863,1.978,2.728-.06,4.058,0A1.757,1.757,0,0,1,5.093.554h0A18.063,18.063,0,0,1,7.733,4.127C7.994,5.377,6.5,6.1,6.959,7.358a10.562,10.562,0,0,0,6.012,6.009c1.259.457,1.98-1.033,3.23-.773a18.043,18.043,0,0,1,3.573,2.64h0a1.753,1.753,0,0,1,.553,1.035c.049,1.4-2.115,3.292-2.537,3.533-1,.713-2.294.7-3.878-.036C9.494,17.928,2.433,11,.56,6.416-.156,4.841-.2,3.534.524,2.539Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M0,0A8.527,8.527,0,0,1,7.533,7.523",
    transform: "translate(12.908 0.267)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M0,0A4.735,4.735,0,0,1,3.742,3.742",
    transform: "translate(12.908 4.058)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.a9fa0e203302e60abcd65fbc5ca51912.svg";
export { ForwardRef as ReactComponent };